export default __webpack_public_path__ + "static/media/keller-user-flow-thumb.0dd87e1c.jpg";